import type { IntlError } from "./errors";

/**
 * Error handler passed into `onError` of <IntlProvider />
 * It's recommended to throw during development if id isn't found to catch missing translations
 * @param err error object thrown from IntlProvider
 */
export const onLocaleError = (err: IntlError) => {
    if (
        "code" in err &&
        err?.code === "MISSING_TRANSLATION" &&
        process.env.NODE_ENV === "development"
    ) {
        throw new Error(
            `Unable to find i18n translation. If adding a new package, import the "<locale>.json" into application. Original error: ${err.message}`
        );
    } else {
        console.error(err);
    }
};
